
import React, { useState, useEffect } from "react";
import PopoverInput from "./inner/popoverInput.jsx";
import PickerFooter from "./inner/pickerFooter.jsx";
// "Clear" resets the party to a single room of two adults.
const DEFAULT_PARTY = [{ adults: 2, children: [], infants: 0 }];
const MAX_ROOMS = 3;
const MAX_PAX = 9;

const MAX_ADULTS_IN_ROOM = 6;
const MAX_CHILDREN_IN_ROOM = 4;
const MAX_INFANTS_IN_ROOM = 2;
const CHILD_AGES = [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12,13,14,15,16,17];

const minus_icon = <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18 12H6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
</svg>;
const plus_icon = <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 6V18M6 12H18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
</svg>;
const icon = <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3 9L12 2L21 9V20C21 20.5304 20.7893 21.0391 20.4142 21.4142C20.0391 21.7893 19.5304 22 19 22H5C4.46957 22 3.96086 21.7893 3.58579 21.4142C3.21071 21.0391 3 20.5304 3 20V9Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M9 22V12H15V22" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
</svg>;

const ChildAgePicker = ({ age, roomIdx, childIdx, events }) => {
    return <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2 pl-3 border-solid border-primary border-l">
            <div className="text-content_3">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 2C8.27232 2 5.14012 4.54955 4.25203 8H3.5C2.67157 8 2 8.67157 2 9.5C2 10.3284 2.67157 11 3.5 11H4.06189C4.55399 14.9463 7.92038 18 12 18C16.0796 18 19.446 14.9463 19.9381 11H20C20.8284 11 21.5 10.3284 21.5 9.5C21.5 8.67157 20.8284 8 20 8H19.748C18.8599 4.54955 15.7277 2 12 2ZM12 2C12 5.31371 9.31371 8 6 8H4.5M12 2C12 5.31371 14.6863 8 18 8H19.5M18 22C18 20.208 17.2144 18.5994 15.9687 17.5M6 22C6 20.208 6.78563 18.5994 8.03126 17.5M9 10V10.01M15 10V10.01M12 15C12.5523 15 13 14.5523 13 14H11C11 14.5523 11.4477 15 12 15Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
            </div>
            <span className="text-sm text-primary">Age of Child {childIdx + 1}</span>
        </div>
        <div className="flex items-center gap-1">
            <select className="form-input" value={age} onChange={e => events.setChildAge(roomIdx, childIdx, parseInt(e.target.value))}>
                {CHILD_AGES.map((x) => {
                    return <option key={x}>{x}</option>;
                })}
            </select>
        </div>
    </div>
}
const Room = ({ room, roomIdx, events,hasMaxPax }) => {
    const hasOneAdult = room.adults == 1;
    const hasMaxAdultsInRoom = room.adults == MAX_ADULTS_IN_ROOM;
    const hasNoChildrem = room.children.length == 0;
    const hasMaxChildrenInRoom = room.children.length == MAX_CHILDREN_IN_ROOM;
    const hasNoInfants = room.infants == 0;
    const hasMaxInfantsInRoom = room.infants == MAX_INFANTS_IN_ROOM;
    return (<div className="mb-6">
        <h4 className="text-md font-semibold text-content_2 mb-4">Room {roomIdx + 1}</h4>
        <div className="flex items-center justify-between mb-4">
            <div className="flex items-center gap-2">
                <div className="text-content_3">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path d="M8 15C8.91212 16.2144 10.3643 17 12 17C13.6357 17 15.0879 16.2144 16 15M8.00897 9H8M16 9H15.991M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </div>
                <span className="text-md text-primary">Adults</span>
            </div>
            <div className="flex items-center gap-1">
                <button type="button" onClick={() => events.removeAdult(roomIdx)}
                    disabled={hasOneAdult}
                    className={"form-quantity-button " + (hasOneAdult ? 'opacity-50 cursor-not-allowed' : 'hover:bg-gray-100')}>
                    {minus_icon}
                </button>
                <span className="text-lg font-bold text-secondary w-[30px] text-center">{room.adults}</span>
                <button type="button" onClick={() => events.addAdult(roomIdx)}
                    disabled={hasMaxAdultsInRoom || hasMaxPax}
                    className={"form-quantity-button " + ((hasMaxAdultsInRoom || hasMaxPax) ? 'opacity-50 cursor-not-allowed' : 'hover:bg-gray-100')}>
                    {plus_icon}
                </button>
            </div>
        </div>


        <div className="flex items-center justify-between mb-4">
            <div className="flex items-center gap-2">
                <div className="text-content_3">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 2C8.27232 2 5.14012 4.54955 4.25203 8H3.5C2.67157 8 2 8.67157 2 9.5C2 10.3284 2.67157 11 3.5 11H4.06189C4.55399 14.9463 7.92038 18 12 18C16.0796 18 19.446 14.9463 19.9381 11H20C20.8284 11 21.5 10.3284 21.5 9.5C21.5 8.67157 20.8284 8 20 8H19.748C18.8599 4.54955 15.7277 2 12 2ZM12 2C12 5.31371 9.31371 8 6 8H4.5M12 2C12 5.31371 14.6863 8 18 8H19.5M18 22C18 20.208 17.2144 18.5994 15.9687 17.5M6 22C6 20.208 6.78563 18.5994 8.03126 17.5M9 10V10.01M15 10V10.01M12 15C12.5523 15 13 14.5523 13 14H11C11 14.5523 11.4477 15 12 15Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </div>
                <span className="text-md text-primary">Children</span>
            </div>
            <div className="flex items-center gap-1">
                <button type="button" onClick={() => events.removeChild(roomIdx)}
                    disabled={hasNoChildrem}
                    className={"form-quantity-button " + (hasNoChildrem ? 'opacity-50 cursor-not-allowed' : 'hover:bg-gray-100')}>
                    {minus_icon}
                </button>
                <span className="text-lg font-bold text-secondary w-[30px] text-center">{room.children.length}</span>
                <button type="button" onClick={() => events.addChild(roomIdx)}
                    disabled={hasMaxChildrenInRoom || hasMaxPax}
                    className={"form-quantity-button " + ((hasMaxChildrenInRoom || hasMaxPax) ? 'opacity-50 cursor-not-allowed' : 'hover:bg-gray-100')}>
                    {plus_icon}
                </button>
            </div>
        </div>

        {room.children.map((age, childIdx) => {
            return <ChildAgePicker age={age} roomIdx={roomIdx} childIdx={childIdx} key={childIdx} events={events} />
        })}

        <div className="flex items-center justify-between mb-4">
            <div className="flex items-center gap-2">
                <div className="text-content_3">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 2C8.68629 2 6 4.68629 6 8C6 11.3137 8.68629 14 12 14C15.3137 14 18 11.3137 18 8C18 4.68629 15.3137 2 12 2ZM12 2C11.0059 2 10.2 2.7835 10.2 3.75C10.2 4.7165 11.0059 5.5 12 5.5C12.461 5.5 12.8815 5.3315 13.2 5.0544M16.874 12C17.5826 13.037 18 14.3093 18 15.6842C18 16.5017 17.8524 17.2829 17.5838 18M17.5838 18C16.7064 20.3424 14.5371 22 12 22C8.68629 22 6 19.1723 6 15.6842C6 14.3093 6.41738 13.037 7.12605 12M17.5838 18C14.8509 16.8 12.0559 14.8333 11 14M10 8H10.0081M14 8H14.0081" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
                    </svg>
                </div>
                <span className="text-md text-primary">Infants</span>
            </div>
            <div className="flex items-center gap-1">
                <button type="button" onClick={() => events.removeInfant(roomIdx)}
                    disabled={hasNoInfants}
                    className={"form-quantity-button " + (hasNoInfants ? 'opacity-50 cursor-not-allowed' : 'hover:bg-gray-100')}>
                    {minus_icon}
                </button>
                <span className="text-lg font-bold text-secondary w-[30px] text-center">{room.infants}</span>
                <button type="button" onClick={() => events.addInfant(roomIdx)}
                    disabled={hasMaxInfantsInRoom}
                    className={"form-quantity-button " + (hasMaxInfantsInRoom ? 'opacity-50 cursor-not-allowed' : 'hover:bg-gray-100')}>
                    {plus_icon}
                </button>
            </div>
        </div>
    </div>);
}
const PaxPicker = ({ rooms, onChange }) => {

    if (rooms.length == 0) {
        rooms = [{ adults: 1, children: [], infants: 0 }];
    }
    const [isOpen, setIsOpen] = useState(false);
    const removeRoom = () => {
        var newARr = [...rooms];
        newARr.pop();
        onChange(newARr);
    };

    const addRoom = () => {
        onChange([...rooms, { adults: 1, children: [], infants: 0 }]);
    };

    const addAdult = (roomIdx) => {
        var newArr = [...rooms];
        newArr[roomIdx].adults++;
        onChange(newArr);
    };

    const removeAdult = (roomIdx) => {
        var newArr = [...rooms];
        newArr[roomIdx].adults--;
        onChange(newArr);
    };

    const addChild = (roomIdx) => {
        var newArr = [...rooms];
        var childArr = newArr[roomIdx].children;
        childArr.push(2);
        onChange(newArr);
    };

    const removeChild = (roomIdx) => {
        var newArr = [...rooms];
        var childArr = newArr[roomIdx].children;
        childArr.pop();
        onChange(newArr);
    };

    const setChildAge = (roomIdx, childIdx, age) => {
        var newArr = [...rooms];
        newArr[roomIdx].children[childIdx] = age;
        onChange(newArr);
    };

    const addInfant = (roomIdx) => {
        var newArr = [...rooms];
        newArr[roomIdx].infants++;
        onChange(newArr);
    };

    const removeInfant = (roomIdx) => {
        var newArr = [...rooms];
        newArr[roomIdx].infants--;
        onChange(newArr);
    };
 
    const getRoomSummary = () => {
        const totalRooms = rooms.length || 0;
        const totalAdults = rooms.reduce(
            (sum, room) => sum + room.adults,
            0
        );
        const totalChildren = rooms.reduce(
            (sum, room) => sum + room.children.length,
            0
        );
        const totalInfants = rooms.reduce(
            (sum, room) => sum + room.infants,
            0
        );

        if (totalRooms === 0) return "Choose your room(s)";

        // Skip zero counts and pluralise properly - the full four-part string
        // ("1 Rooms, 2 Adults, 0 Children, 0 Infants") overflows the input.
        const parts = [
            `${totalRooms} ${totalRooms == 1 ? "Room" : "Rooms"}`,
            `${totalAdults} ${totalAdults == 1 ? "Adult" : "Adults"}`,
        ];
        if (totalChildren > 0) parts.push(`${totalChildren} ${totalChildren == 1 ? "Child" : "Children"}`);
        if (totalInfants > 0) parts.push(`${totalInfants} ${totalInfants == 1 ? "Infant" : "Infants"}`);
        return parts.join(", ");
    };


    const events = { addAdult, removeAdult, addChild, addInfant, removeChild, removeInfant, setChildAge }
    const currentRoomCount = rooms.length;
    const hasOneRoom = currentRoomCount == 1;
    const hasMaxRooms = currentRoomCount == MAX_ROOMS;
    const hasMaxPax = rooms.reduce(
        (sum, room) => sum + room.adults + room.children.length,
        0
    ) == MAX_PAX;
    const isDefaultParty = rooms.length == 1 && rooms[0].adults == 2 && rooms[0].children.length == 0 && rooms[0].infants == 0;
    const paxFooter = (
        <div className="space-y-2">
            {(hasMaxRooms || hasMaxPax) && (
                <div className="px-4 py-1 rounded-xl bg-ocean-200 text-emp_dark text-center justify-center drop-shadow-sm">
                    Travelling with a larger group? <br />Call us on <a href="tel:+442084926896" className="underline font-semibold text-emp">020 8492 6896</a>.
                </div>
            )}
            <PickerFooter onClear={() => onChange(DEFAULT_PARTY)} onConfirm={() => setIsOpen(false)} clearDisabled={isDefaultParty} />
        </div>
    );
    return <PopoverInput footer={paxFooter} icon={icon} isLoading={false} filterText={getRoomSummary()} doubleWidth={false} isOpen={isOpen} setIsOpen={setIsOpen}>
        <div className="text-secondary">
            <div className="mb-4">
                <h3 className="text-md font-semibold text-content_2">Choose your room(s)</h3>
            </div>
            <div className="flex items-center justify-between pb-4">
                <div className="flex items-center gap-2">
                    <div className="text-content_3">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M2 3.5V20.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M22 8.5V20.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M2 8.5L6 10.5H22" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M2 15.5H6M22 15.5H19" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M6 10.5V16.5C6 18.1547 6.34533 18.5 8 18.5H17C18.6547 18.5 19 18.1547 19 16.5V10.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M6.81362 10.5C6.89385 10.076 7.0202 9.63248 6.99567 9.19713C6.95941 8.5536 6.63697 7.96625 6.1264 7.61368C5.92478 7.47446 5.48 7.33239 5.01268 7.21093C4.3308 7.0337 3.98986 6.94508 3.59142 7.03644C3.30841 7.10133 3.06258 7.25187 2.71115 7.52079C2.67243 7.55042 2.65307 7.56523 2.62289 7.59026C2.3843 7.78812 2.17276 8.07424 2.05352 8.36034C2.03844 8.39653 2.02562 8.43102 2 8.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </div>
                    <span className="text-md text-primary">Room(s)</span>
                </div>
                <div className="flex items-center gap-1">
                    <button type="button" onClick={() => removeRoom()} disabled={hasOneRoom}
                        className={"form-quantity-button " + (hasOneRoom ? 'opacity-50 cursor-not-allowed' : 'hover:bg-gray-100')}>
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M18 12H6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                        </svg>
                    </button>
                    <span className="text-lg font-bold text-secondary w-[30px] text-center">{currentRoomCount}</span>
                    <button type="button" onClick={() => addRoom()} disabled={(hasMaxRooms || hasMaxPax)} className={"form-quantity-button " + (hasMaxRooms ? 'opacity-50 cursor-not-allowed' : 'hover:bg-gray-100')}>
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12 6V18M6 12H18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                        </svg>
                    </button>
                </div>
            </div>
            {rooms.map((x, i) => {
                return <Room room={x} roomIdx={i} key={i} events={events} hasMaxPax={hasMaxPax}/>
            })}
        
        </div>
    </PopoverInput >
}
export default PaxPicker;
